import Axios from 'axios'
import {
  SYSSUBMENU_UNSET_ALL_STATE,
  SYSSUBMENU_SET_MSG,
  SYSSUBMENU_UNSET_MSG,
  SYSSUBMENU_SET_SCHEMA,
  SYSSUBMENU_UNSET_SCHEMA,
  SYSSUBMENU_SET_ACTION_PROCESS,
  SYSSUBMENU_UNSET_ACTION_PROCESS,
  SYSSUBMENU_SET_LIST_DATA,
  SYSSUBMENU_UNSET_LIST_DATA,
  SYSSUBMENU_SET_ACTION_STATUS,
  SYSSUBMENU_UNSET_ACTION_STATUS

} from '../mutation-types'

const state = {
  dataList: [],
  message: '',
  actionStatus: false,
  actionProcess: false,
  Schema: {
    id: 0,
    menu_id: '',
    submenu_name: '',
    sl_no: '',
    description: '',
    css_class: '',
    route: '',
    url: '',
    active: 1
  }
}

const getters = {
  get_SYSSUBMENU_DataList(state) {
    return state.dataList;
  },
  get_SYSSUBMENU_ActionMessage(state) {
    return state.message;
  },
  get_SYSSUBMENU_Schema(state) {
    return state.Schema
  },
  get_SYSSUBMENU_ActionProcess(state) {
    return state.actionProcess;
  },
  get_SYSSUBMENU_ActionStatus(state) {
    return state.actionStatus;
  },

}

// mutations

const mutations = {
  [SYSSUBMENU_UNSET_ALL_STATE](state) {
    state.actionProcess = false,
      state.dataList = [],
      state.Schema = {
        id: 0,
        menu_id: '',
        submenu_name: '',
        sl_no: '',
        description: '',
        css_class: '',
        route: '',
        url: '',
        active: 1
      }
  },
  [SYSSUBMENU_SET_ACTION_STATUS](state) {
    state.actionStatus = true
  },
  [SYSSUBMENU_UNSET_ACTION_STATUS](state) {
    state.actionStatus = false
  },
  [SYSSUBMENU_SET_MSG](state, msg) {
    state.message = msg
  },
  [SYSSUBMENU_UNSET_MSG](state) {
    state.message = ""
  },
  [SYSSUBMENU_UNSET_ACTION_PROCESS](state) {
    state.actionProcess = false
  },
  [SYSSUBMENU_SET_ACTION_PROCESS](state) {
    state.actionProcess = true
  },
  [SYSSUBMENU_SET_LIST_DATA](state, itemList) {
    state.dataList = itemList
  },
  [SYSSUBMENU_UNSET_LIST_DATA](state) {
    state.dataList = []
  },
  [SYSSUBMENU_SET_SCHEMA](state, schemaData) {
    state.Schema = schemaData
  },
  [SYSSUBMENU_UNSET_SCHEMA](state) {
    state.Schema = []
    state.Schema.active = 1
  },
}

// Actions

const actions = {
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/module/dia_sysSubmenu_module.js